import {
  DEFAULT_BORDER_RADIUS,
  DEFAULT_BORDER_SIZE,
  DEFAULT_FONT_SIZE,
  DEFAULT_LETTER_SPACING,
  DEFAULT_PADDING,
  DEFAULT_TAG_COLOR_MODE,
  DEFAULT_TAG_VARIANT,
  DEFAULT_UNIFORM_COLOR,
  PREDEFINED_TAG_COLORS,
  TAG_COLORS,
  TagColor,
  TagColorMode,
  TagType,
  TagVariant
} from '@treneo/shared/constants';

export {
  DEFAULT_BORDER_RADIUS,
  DEFAULT_BORDER_SIZE,
  DEFAULT_FONT_SIZE,
  DEFAULT_LETTER_SPACING,
  DEFAULT_PADDING,
  DEFAULT_TAG_COLOR_MODE,
  DEFAULT_TAG_VARIANT,
  DEFAULT_UNIFORM_COLOR,
  PREDEFINED_TAG_COLORS,
  TAG_COLORS,
  TagColor,
  TagColorMode,
  TagType,
  TagVariant
};

export const TAG_VARIANT_OPTIONS = [
  { value: TagVariant.FILLED, label: 'Filled' },
  { value: TagVariant.OUTLINED, label: 'Outlined' },
  { value: TagVariant.NONE, label: 'None (hide in app)' }
];

export const TAG_COLOR_MODE_OPTIONS = [
  { value: TagColorMode.COLORFUL, label: 'Colorful (each tag different color)' },
  { value: TagColorMode.UNIFORM, label: 'Uniform (all tags same color)' }
];

export const BORDER_SIZE_RANGE = {
  MIN: 1,
  MAX: 10,
  DEFAULT: DEFAULT_BORDER_SIZE
};

export const FONT_SIZE_RANGE = {
  MIN: 8,
  MAX: 24,
  DEFAULT: DEFAULT_FONT_SIZE
};

export const TAG_STYLING_DEFAULTS = {
  uniformColor: DEFAULT_UNIFORM_COLOR,
  borderSize: DEFAULT_BORDER_SIZE,
  fontSize: DEFAULT_FONT_SIZE,
  borderRadius: DEFAULT_BORDER_RADIUS,
  letterSpacing: DEFAULT_LETTER_SPACING,
  padding: DEFAULT_PADDING
} as const;
